/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  FontWeight,
  Text,
} from '@doveit/bricks';
import { formatDate } from '@doveit/hammer';
import { BrandTemplate } from '../../../providers/api/dtos';
import { goToPage } from '../../../utils/navigate/utils';
import * as styles from './CanvaModelHCard.style';
import CanvaDesignPreview from '../canva-design-preview/CanvaDesignPreview';
import { CANVA_CARD_ASPECT_RATIO } from '../../constants';

export interface CanvaModelHCardProps {
  brandTemplate: BrandTemplate,
}

const CanvaModelHCard: React.FC<CanvaModelHCardProps> = ({
  brandTemplate,
}) => {
  const handleView = React.useCallback(() => {
    goToPage(brandTemplate.viewUrl);
  }, [brandTemplate.viewUrl]);

  return (
    <div css={styles.container}>
      <div
        role="button"
        css={styles.preview}
        aria-label="Visualizza template su Canva"
        onClick={handleView}
      >
        {brandTemplate.thumbnail?.url && (
          <CanvaDesignPreview
            aspectRatio={CANVA_CARD_ASPECT_RATIO}
            src={brandTemplate.thumbnail.url}
            alt={brandTemplate.title}
            color="neutral"
          />
        )}
      </div>
      <div css={styles.info}>
        <p css={styles.title}>{brandTemplate.title}</p>
        <Text.Caption fontWeight={FontWeight.LIGHT}>
          Creato il {formatDate(new Date(brandTemplate.createdAt))}
        </Text.Caption>
      </div>
    </div>
  );
};

export default CanvaModelHCard;
